import {
  SIGNUP,
  GETALLHOSPITALANDUSERINFO,
  GETEMAILVERIFICATION,
  CREATE_EMAIL_OTP_RECORD,
  CREATE_CHECK_RECORD,
  SEND_MOBILE_OTP,
  VERIFY_MOBILE_OTP,
  SEND_REGISTRATION_SMS,
  SEND_MOBILE_AND_EMAIL_OTP,
  VERIFY_MOBILE_AND_EMAIL_OTP,
  VERIFY_MOBILE_AND_EMAIL_OTP_ERROR,
} from "../actions/types";

const initialState = {
  HospitalanduserList: [],
  SignupList: null,
  emailVerificationList: [],
  createOtpVerificationList: null,
  lastOtpCreationSuccess: null,
  isMobileVerified: false,
  mobileOtpResponse: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SIGNUP:
      return {
        ...state,
        SignupList: action.payload.data,
      };

    case GETALLHOSPITALANDUSERINFO:
      return {
        ...state,
        HospitalanduserList: action.payload.data,
      };

    case GETEMAILVERIFICATION:
      return {
        ...state,
        emailVerificationList: Array.isArray(action.payload.data)
          ? action.payload.data
          : [],
      };

    case CREATE_EMAIL_OTP_RECORD:
      const newOtpEntry = action.payload.data;
      const updatedList = (state.emailVerificationList || []).filter(
        (item) => item && item.email !== newOtpEntry.email,
      );
      updatedList.push(newOtpEntry);

      return {
        ...state,
        emailVerificationList: updatedList,
        lastOtpCreationSuccess: action.payload.success,
        createOtpVerificationList: action.payload.success,
      };

    case CREATE_CHECK_RECORD:
      return {
        ...state,
        otpVerificationResult: action.payload,
      };
    case SEND_MOBILE_OTP:
      return { ...state, mobileOtpResponse: action.payload };
    case VERIFY_MOBILE_OTP:
      return {
        ...state,
        isMobileVerified:
          action.payload.success === 1 || action.payload.success === true,
      };
    case SEND_REGISTRATION_SMS:
      return {
        ...state,
        registrationSmsResponse: action.payload,
      };

    case SEND_MOBILE_AND_EMAIL_OTP:
      return {
        ...state,
        mobileOtpResponse: action.payload,
      };

    case VERIFY_MOBILE_AND_EMAIL_OTP:
      return {
        ...state,
        verifyOtpResponse: action.payload,
        isMobileVerified:
          action.payload?.success === 1 || action.payload?.success === true,
      };

    case VERIFY_MOBILE_AND_EMAIL_OTP_ERROR:
      return {
        ...state,
        isMobileVerified: false,
        verifyOtpError: action.payload,
      };
    default:
      return state;
  }
}
